var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('div', [_c('Loading')], 1) : [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.moduleConfig.list_page && _vm.moduleConfig.list_page.form_title) + " ")]), _vm.moduleConfig.list_page && _vm.moduleConfig.list_page.form_desc ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.moduleConfig.list_page && _vm.moduleConfig.list_page.form_desc))]) : _vm._e(), _vm.invoiceLogs.length ? [_c('ul', _vm._l(_vm.invoiceLogs, function (invoiceLog, i) {
    return _c('li', {
      key: i,
      staticClass: "s-mb-3"
    }, [_c('Item', {
      attrs: {
        "invoiceLog": invoiceLog,
        "show-image": false
      }
    })], 1);
  }), 0), _c('Pagination', {
    attrs: {
      "total-page": _vm.lastPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })] : _c('div', {
    staticClass: "s-pt-40 s-text-center"
  }, [_c('img', {
    staticClass: "s-mb-3",
    attrs: {
      "src": require("@/assets/images/liff/empty.svg")
    }
  }), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("尚未上傳任何發票")])])], 2)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }